import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-auth-footer',
  standalone: true,
  imports: [RouterModule, TranslateModule],
  templateUrl: './auth-footer.component.html',
})
export class AuthFooterComponent {
  readonly year = new Date().getFullYear();
}
